import React from "react";
import styles from "./styles.css";
import { FIELD_TYPES } from "globals/constants";

import {
    getMinLengthError,
    getMaxLengthError,
    getMinItemsError,
    getMaxItemsError,
} from "./errorMessages";

const FlowableErrorComponent = ({ type, extraSettings, customValidations = [], empty, minError, maxError,
	minLengthError, maxLengthError }) => {
    const customValidationErrors = customValidations
        .filter(validation => !validation.expression)
        .map(validation => validation.errorMsg);

    const errors = [];

    if (empty) {
        errors.push("Field must not be empty");
    }

    if (type === FIELD_TYPES.RICH_TEXT) {
        if (minError) {
            errors.push(getMinLengthError(minLengthError, extraSettings.minLength));
        }

        if (maxError) {
            errors.push(getMaxLengthError(maxLengthError, extraSettings.maxLength));
        }
    } else {
        if (minError) {
            errors.push(getMinItemsError(extraSettings.minItemsErrorMessage, extraSettings.minItems));
        }

        if (maxError) {
            errors.push(getMaxItemsError(extraSettings.maxItemsErrorMessage, extraSettings.maxItems));
        }
    }

    errors.push(...customValidationErrors);

    if (errors.length > 0) {
        return (
            <div>
                {errors.map((error, index) => (
                    <span key={index} className={styles.error}>
                        {error}
                    </span>
                ))}
            </div>
        );
    }

    return <></>;
};

export default FlowableErrorComponent;